import { NgModule }       from '@angular/core';
import { RouterModule } from '@angular/router';
import { Tabbar, TabHeader } from "./routing-tabs";
import { CommonModule }        from '@angular/common';
import { CustomPaginationControls } from "./custom-pagination-controls/custom-pagination-controls.component"

import { PaginatePipe } from '../../lib/ng2-pagination/paginate-pipe';
import { PaginationControlsCmp } from '../../lib/ng2-pagination/pagination-controls-cmp';
import { PaginationService } from '../../lib/ng2-pagination/pagination-service';

import {  NumberField } from "./number-field/number-field.component"
import { Spinner } from "./spinner/spinner.component"
import { CssSpinner } from "./css-spinner/css-spinner.component"
import { SpanButton  } from "./span-button/span-button.component"
import { Checkbox } from "./checkbox/checkbox.component"
import { Colorpicker } from "./colorpicker/colorpicker.component"
import { Popup } from "./popup/popup.component"
import { DebounceClickDirective } from './debounce.directive';

import { DataTable } from "./data-table/data-table.component"


import {  Alert } from "./alert/alert.component"
import { Combobox } from "./combobox/combobox.component"
import { ComboboxAjax } from "./combobox/combobox-ajax.component"
import { Tab  } from "./tab/tab.component"
import { Tabs  } from "./tabs/tabs.component"
import { LeoBox } from "./leo-box/leo-box.component"
import { LeoInfo } from "./leo-info/leo-info.component"
import { DateTimePicker } from "./date-time-picker/date-time-picker.component"
import { DatePicker } from "./date-time-picker/date-picker.component"
import { TimePicker } from "./date-time-picker/time-picker.component"
import { ControlMessages } from "./control-messages/control-messages.component"
import {  Fees } from "./fee-form/fees.component"

import {  PriceForm } from "./price-form/price-form.component"

import { EventBasicDataForm  } from "./event-basic-data-form/event-basic-data-form.component"
import { SeatsForm  } from "./seats-form/seats-form.component"
import { Modal } from "./modal/modal.component"

import { Files  } from "./files/files.component"
import { YoutubeVideosComponent  } from "./youtube-videos/youtube-videos.component"
import { YoutubeIframe } from "./youtube-iframe/youtube-iframe.component"
import { GoogleMapComponent  } from "./google-map/google-map.component"

import { Loader  } from "./loader/loader.component"
import {  CategoryForm } from "./category-form/category-form.component"

import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { StringDatePipe } from "./string-date.pipe";
import { StringTimePipe } from "./string-time.pipe";
import { StringDateNoTimePipe } from "./string-date-no-time.pipe";
import { ReplacePipe } from "./replace.pipe";
import { SortStringPipe } from "./sort-string.pipe";
import { WebsiteURLPipe } from "./websiteURL.pipe";


import { MathAbsPipe } from "./math-abs.pipe";
import { AgmCoreModule } from '@agm/core';

import { HasRole } from "./hasRole/has-role.component";
import { HasAnyRole } from "./hasRole/has-any-role.directive";
import { HasRoles } from "./hasRole/has-roles.directive";
import { HasNotRole } from "./hasRole/has-not-role.component";
import { HasMerchantIdOrRole } from "./hasRole/has-merchant-id-or-role.component";
import { HasFeatureAccessDirective } from "./hasFeatureAccess/has-feature-access.directive";

import { TooltipDirective } from './tooltip/tooltip.directive';

import { TicketDesingPresentation } from './ticket-design-presentation/ticket-print/ticket-print.presentation';
import { PrintAtHomePresentation } from './ticket-design-presentation/print-at-home/print-at-home.presentation';

import { EventInfo } from 'app/ui-helper/event-info';

import { Help } from 'app/ui-helper/help/help.component';

import { ScrollTopButtonComponent } from "./scroll-top-button/scroll-top-button.component"
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { AccessCodesComponent } from "./price-form/access-codes/access-codes.component";
import { AccessCodesPresentation } from "./price-form/access-codes/access-codes.presentation";
import { KeepAppointmentComponent } from "../components/keep-appointment/keep-appointment.component"
import { KeepAppointmentEffect } from 'app/components/keep-appointment';
import { EffectsModule } from "@ngrx/effects"
import { DownloadStatusComponent } from "./download-status/download-status.component";
import { DownloadStatusPresentation } from "./download-status/download-status.presentation";
import { CounterDoneReportsComponent } from "./download-status/counter-done-reports/counter-done-reports.component";
import { ReportJobService } from "./download-status/report-job.service";

const TO_EXPORT = [
		Tabbar,
		TabHeader,
		CustomPaginationControls,
		PaginationControlsCmp,
		PaginatePipe,
		DateTimePicker,
		DatePicker,
		TimePicker,
		Combobox,
		ComboboxAjax,
		Colorpicker,
		LeoBox,
		LeoInfo,
		Checkbox,
		ControlMessages,
		Modal,
		Popup,
		ReplacePipe,
		SortStringPipe,
		StringDatePipe,
		StringTimePipe,
		StringDateNoTimePipe,
		MathAbsPipe,
		WebsiteURLPipe,
		Spinner,
		CssSpinner,
		SpanButton,
		NumberField,
		DebounceClickDirective,
		DataTable,
		Alert,
		Tab,
		Tabs,
		Fees,
		PriceForm,
		AccessCodesComponent,
		AccessCodesPresentation,
		EventBasicDataForm,
		EventInfo,
		Help,
		SeatsForm,
		Files,
		YoutubeVideosComponent,
		YoutubeIframe,
		GoogleMapComponent,
		Loader,
		CategoryForm,
		HasRole,
		HasAnyRole,
		HasRoles,
		HasNotRole,
		HasMerchantIdOrRole,
		HasFeatureAccessDirective,
		TooltipDirective,
		TicketDesingPresentation,
		PrintAtHomePresentation,
		ScrollTopButtonComponent,
		KeepAppointmentComponent
]

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		ReactiveFormsModule,
		FormsModule,
		AgmCoreModule,
		DragulaModule,
		EffectsModule.forFeature([KeepAppointmentEffect])
	],
	declarations: [
		...TO_EXPORT,
		DownloadStatusComponent,
		DownloadStatusPresentation,
		CounterDoneReportsComponent
	],
	exports: [
		...TO_EXPORT,
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		DownloadStatusComponent,
		CounterDoneReportsComponent
	],
	providers: [
		PaginationService,
		DragulaService,
		StringDateNoTimePipe,
		ReportJobService
	]
})
export class UiHelperModule {
	static forRoot() {
		return {
			ngModule: UiHelperModule
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/ui-helper/ui-helper.module.ts